export default "__VITE_ASSET__C1BKgTU$__"